import type { Source } from '@jarvis/shared';
import { Icon } from './Icon';

const domain = (url: string) => { try { return new URL(url).hostname.replace(/^www\./, ''); } catch { return url; } };

/* Fontes de uma resposta com busca na web: sempre visíveis, sempre com link. */
export function Sources({ items, compact = false }: { items: Source[]; compact?: boolean }) {
  if (!items.length) return null;
  return (
    <div className={`sources ${compact ? 'compact' : ''}`}>
      <span className="sources-k"><Icon name="search" />Fontes</span>
      <ol>
        {items.map((s, i) => (
          <li key={s.url}>
            <a href={s.url} target="_blank" rel="noopener noreferrer" title={s.url}>
              <span className="src-n">{i + 1}</span>
              <span className="src-t">{s.title}</span>
              <span className="src-d">{domain(s.url)}</span>
            </a>
          </li>
        ))}
      </ol>
    </div>
  );
}
